import { NavigateFunction } from 'react-router-dom';
import { User } from '@domain/account/models/User';
import { Company } from '@domain/account/models/Company';
import { container } from '@infrastructure/container';
import { useAuthStore } from '../../../application/store/AuthStore';
import { resolvePostAuthRedirect } from '../../../features/connections/shopify/pendingInstall';

interface CompleteSignInOptions {
  navigate: NavigateFunction;
  user: User;
  jwt: string;
  login: (user: User, jwt: string, company?: Company) => Promise<void>;
  redirect?: string;
}

export async function completeSignIn({
  navigate,
  user,
  jwt,
  login,
  redirect = resolvePostAuthRedirect(),
}: CompleteSignInOptions): Promise<void> {
  const companies = await container.companyRepository.getCompanies();

  if (companies.status === 'error' || !companies.data?.length) {
    throw new Error('No company found for this account');
  }

  if (companies.data.length === 1) {
    await login(user, jwt, companies.data[0]);
    navigate(redirect);
    return;
  }

  useAuthStore.getState().setAuth(user.id, jwt);
  navigate('/sign-in/select-company', {
    state: { redirect, user, jwt },
  });
}
